// Angular stuff
import { NgModule } from '@angular/core';

// EURO_N stuff
import { AppComponent } from './app.component';
import { CoreModule } from '@core_n/core.module';
import { AroTrackComponent } from './aro/aro-track.component';
import { AroAngularTrackComponent } from './aro/aro-angularTrack.component';
// import { AroAngularTrackCoreComponent } from '../core/app/aro/aro-angularTrack-core.component';
import { AroTrackTabGenComponent } from './aro/aro-track-tab-gen.component';
import { AroTrackTabMnvrComponent } from './aro/aro-track-tab-mnvr.component';
import { AroPlotComponent } from './aro/aro-plot.component';
import { AppConfig } from '@core_n/app.config';
import { SensorBiasComponent } from './sensor-bias/sensor-bias.component';
import { SetDoubleFlagActionComponent } from './user-actions/set-double-flag-action.component';
import { Router } from '@angular/router';
import { SessionService } from '@core_n/common/session.service';
import { AroTrackTabClassificationComponent } from './aro/aro-track-tab-classification.component';
import { AroSensorComponent } from './aro/aro-sensor.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
//import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/Button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog'
import { from } from 'rxjs';
import { DatePipe } from '@angular/common';
import { SignalR, SignalRConfiguration, SignalRModule } from 'ng2-signalr';
import { MatIconModule } from '@angular/material/icon';

export function createConfig() : SignalRConfiguration {
  return new SignalRConfiguration();
}

@NgModule({
  declarations: [
    AppComponent,
    AroTrackComponent,
    AroAngularTrackComponent,
    AroTrackTabGenComponent,
    AroTrackTabMnvrComponent,
    AroPlotComponent,
    SensorBiasComponent,
    SetDoubleFlagActionComponent,
    AroTrackTabClassificationComponent,
    AroSensorComponent,
  ],
  imports: [
    CoreModule,
    SignalRModule.forRoot(createConfig),
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatButtonModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    MatIconModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    AroTrackTabGenComponent,
    AroTrackTabMnvrComponent,
    DatePipe
  ],
  entryComponents: [
    AroTrackComponent,
    AroAngularTrackComponent,
    AroTrackTabGenComponent,
    AroTrackTabMnvrComponent,
    AroPlotComponent,
    SensorBiasComponent,
    SetDoubleFlagActionComponent,
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule {
  constructor(session: SessionService) {
    AppConfig.appName = 'ARM';
    session.setLoggedIn();
  }
}
export function HttpLoaderFactory(http: HttpClient)
{
  return new TranslateHttpLoader(http);
}
